import { bannerGradient } from "../Banner/styles";
import styled from "styled-components";
import breakpoints from "../../utils/breakpoints";

export const FooterContainer = styled.div`
  ${bannerGradient()};
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 3rem 1.5rem;
  border-radius: 0.25rem;
  overflow: hidden;
  color: #333333;
`;

export const ContactInformation = styled.div`
  flex: 0 1 auto;
  margin-right: 3rem;
  height: 450px;
  ${breakpoints.mdMax`
    margin-bottom: 3rem;
  `}

  & > p,
  & > :first-child {
    margin-top: 0;
    margin-bottom: 0;
  }

  & h3 {
    margin-bottom: 0;
  }
`;

export const MapFrameContainer = styled.div`
  max-width: 100%;
  flex: 1 1 auto;

  & > iframe {
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
`;

export const ContactItemWrapper = styled.span`
  display: block;
  padding: 0.5rem 0;

  &:last-child {
    padding-bottom: 0;
  }
`;
